<form [formGroup]="configurationFormRest">
  <div class="form-row row">
    <div class="form-group col-12">
      <div innerHTML="{{'i18n.domain.import-configuration.edit.rest.description'| translate: {URLParam: apiServerUrl} }}"></div>
    </div>
  </div>
  <div class="form-row row">
    <div class="form-group col-xl-4 col-lg-6">
      <label for="ic-restAccessType" class="control-label required">{{'i18n.domain.import-configuration.edit.rest.access-management-type' | translate}}</label>
      <app-button-group id="ic-restAccessType"
        [fieldsEnum]="ExportInterfaceConfigurationRESTAuthType"
        [isNumericEnum]="true"
        formControlName="restAccessType"
        [translateKey]="'i18n.domain.import-configuration.enums.rest-access-type.'">
      </app-button-group>
    </div>
  </div>
  <div class="form-row row">
    @if (configurationFormRest.controls.restAccessType.value === ExportInterfaceConfigurationRESTAuthType.BearerToken) {
      <div class="form-group col-xl-4 col-lg-6">
        <div class="d-flex gap-1">
          <label for="clientId" class="control-label">{{ 'i18n.domain.import-configuration.edit.rest.client-id' | translate }}</label>
          <ejs-tooltip id='ic-tooltip' content="{{ 'i18n.domain.import-configuration.edit.rest.tooltip-id' | translate }}">
            <span class="icon-information"></span>
          </ejs-tooltip>
        </div>
        <input id="ic-clientId" type="text" class="form-control" formControlName="clientId" />
        <app-error-messages [control]="configurationFormRest.controls.clientId"></app-error-messages>
      </div>
    }
    @if (configurationFormRest.controls.restAccessType.value === ExportInterfaceConfigurationRESTAuthType.APIKey) {
      <div class="form-group col-xl-4 col-lg-6">
        <div class="d-flex gap-1">
          <label for="ic-apiKey" class="control-label">{{ 'i18n.domain.import-configuration.edit.rest.api-fix-key' | translate }}</label>
          <ejs-tooltip id='ic-tooltip' content="{{ 'i18n.domain.import-configuration.edit.rest.tooltip-key' | translate }}">
            <span class="icon-information"></span>
          </ejs-tooltip>
        </div>
        <input id="ic-apiKey" type="text" class="form-control" formControlName="apiKey" />
        <app-error-messages [control]="configurationFormRest.controls.apiKey"></app-error-messages>
      </div>
    }
  </div>
  <div class="form-row row">
    @if (configurationFormRest.controls.restAccessType.value === ExportInterfaceConfigurationRESTAuthType.BearerToken) {
      <div class="form-group col-xl-4 col-lg-6">
        <div class="d-flex gap-1">
          <label for="ic-clientSecret" class="control-label">{{ 'i18n.domain.import-configuration.edit.rest.client-secret' | translate }}</label>
          <ejs-tooltip id='ic-tooltip' content="{{ 'i18n.domain.import-configuration.edit.rest.tooltip-secret' | translate }}">
            <span class="icon-information"></span>
          </ejs-tooltip>
        </div>
        <div class="input-group">
          <input type="text"
                 class="form-control e-textbox"
                 id="ic-clientSecret"
                 formControlName="clientSecret">
          <button class="btn btn-icon e-icons icon-renew btn-secondary"
                  title="{{ 'i18n.domain.import-configuration.edit.rest.generate' | translate }}"
                  (click)="configurationFormRest.controls.clientSecret.setValue(null)">
          </button>
        </div>
        <app-error-messages id="ic-error-message" [control]="configurationFormRest.controls.clientSecret"></app-error-messages>
      </div>
    }
    @if (configurationFormRest.controls.restAccessType.value === ExportInterfaceConfigurationRESTAuthType.APIKey) {
      <div class="form-group col-xl-4 col-lg-6">
        <div class="d-flex gap-1">
          <label for="ic-apiValue" class="control-label">{{ 'i18n.domain.import-configuration.edit.rest.api-fix-value' | translate }}</label>
          <ejs-tooltip id='ic-tooltip' content="{{ 'i18n.domain.import-configuration.edit.rest.tooltip-value' | translate }}">
            <span class="icon-information"></span>
          </ejs-tooltip>
        </div>
        <div class="input-group">
          <input type="text"
                 class="form-control e-textbox"
                 id="ic-apiValue"
                 formControlName="apiValue">
          <button class="btn btn-icon e-icons icon-renew btn-secondary"
                  title="{{ 'i18n.domain.import-configuration.edit.rest.generate' | translate }}"
                  (click)="configurationFormRest.controls.apiValue.setValue(null)">
          </button>
        </div>
        <app-error-messages id="ic-error-message" [control]="configurationFormRest.controls.apiValue"></app-error-messages>
      </div>
    }
  </div>
  @if (configurationFormRest.controls.restAccessType.value === ExportInterfaceConfigurationRESTAuthType.BearerToken) {
    <div class="form-row row">
      <div class="form-group col-xl-4 col-lg-6">
        <label for="ic-refreshTokenLifetimeInHours" class="control-label required">{{ 'i18n.domain.import-configuration.edit.rest.refresh-token' | translate }}</label>
        <input id="ic-refreshTokenLifetimeInHours" type="number" class="form-control" formControlName="refreshTokenLifetimeInHours" />
        <app-error-messages [control]="configurationFormRest.controls.refreshTokenLifetimeInHours"></app-error-messages>
      </div>
    </div>
  }
</form>
